import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
  Divider,
  Stack,
  Tabs,
  Tab,
} from "@mui/material";
import {
  MailOutline as MailIcon,
  LockOutlined as LockIcon,
  Visibility,
  VisibilityOff,
  VpnKeyOutlined as KeyIcon,
  ArrowBack,
  BadgeOutlined as MemberIcon,
  PersonOutlined as PersonIcon,
} from "@mui/icons-material";
import { AuthContext } from '../../context/AuthContext';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import { apiUrl } from "../../comp/ApiUrl";
import { Turnstile } from "@marsidev/react-turnstile";

class AuthLogin extends Component {
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      captchaToken: '',
      showPassword: false,
      loginType: "owner", // 'owner' ou 'member'
    };
  }

  handleTogglePassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState({ [id]: value });
  };

  handleTabChange = (event, newValue) => {
    this.setState({ loginType: newValue });
  };

  // Submissão do Formulário de Login
  handleSubmit = (e) => {
    e.preventDefault();
    const { email, password, captchaToken, loginType } = this.state;

    const toastId = toast.loading("Autenticando...");

    // Se preferir endpoints separados, altere o endpoint dinamicamente:
    // const endpoint = loginType === "member" ? `${apiUrl}/oauth/member-login` : `${apiUrl}/oauth/login`;
    const endpoint = `${apiUrl}/oauth/login`;

    fetch(endpoint, {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        password,
        captchaToken,
        loginType, // Envia o tipo de login para o backend
      }),
    })
      .then(async (res) => {
        const data = await res.json();
        toast.dismiss(toastId);

        if (res.status === 200 && data.status === "success") {
          toast.success("Login efetuado com sucesso!");

          if (this.context && this.context.login) {
            this.context.login(true, data.user);
          }

          if (data.redirect_url) {
            window.location.href = data.redirect_url;
          } else {
            window.location.href = "/";
          }
        } else if (res.status === 401) {
          toast.error(data.msg || "Palavra-passe ou Captcha inválido");
        } else if (res.status === 403) {
          toast.warn("Excedeu o limite de tentativas de login");
        } else if (res.status === 404) {
          toast.error(data.msg || "Utilizador inativo ou não encontrado");
        } else {
          toast.error("Ocorreu um erro ao tentar entrar.");
        }
      })
      .catch((err) => {
        toast.dismiss(toastId);
        console.error(err);
        toast.error("Erro ao ligar ao servidor.");
      });
  };

  handleGoogleSuccess = (credentialResponse) => {
    const toastId = toast.loading("Autenticando com Google...");

    fetch(`${apiUrl}/oauth/google`, {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        credential: credentialResponse.credential,
      }),
    })
      .then(async (res) => {
        toast.dismiss(toastId);
        if (res.status === 200) {
          this.context.login(true);
          window.location.href = "/";
        } else {
          toast.error("Erro na autenticação com Google.");
        }
      })
      .catch(() => {
        toast.dismiss(toastId);
        toast.error("Erro de ligação ao servidor.");
      });
  };

  render() {
    const { email, password, showPassword, loginType } = this.state;

    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          p: 2,
        }}
      >
        <Container maxWidth="xs">
          <Paper
            elevation={6}
            sx={{
              p: 4,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Box sx={{ textAlign: "center", mb: 1 }}>
              <Typography variant="h5" component="h1" fontWeight="bold">
                {loginType === "member" ? "Acesso de Membro" : "Entrar na sua conta"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {loginType === "member"
                  ? "Acesse o painel da equipa (Cozinha / KDS / Atendimento)"
                  : "Acesse a sua conta de proprietário"}
              </Typography>
            </Box>

            {/* Alternador de Tipo de Login (Proprietário vs Membro) */}
            <Tabs
              value={loginType}
              onChange={this.handleTabChange}
              variant="fullWidth"
              sx={{ mb: 1, borderBottom: 1, borderColor: "divider" }}
            >
              <Tab icon={<PersonIcon fontSize="small" />} iconPosition="start" label="Proprietário" value="owner" />
              <Tab icon={<MemberIcon fontSize="small" />} iconPosition="start" label="Membro" value="member" />
            </Tabs>

            {/* Google Login Container (Oculto se for login de membro, se aplicável) */}
            {loginType === "owner" && (
              <>
                <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                  <GoogleOAuthProvider clientId="992901332964-450q4r6gduuii5fo9be5ec8hnbk0rk56.apps.googleusercontent.com">
                    <GoogleLogin
                      onSuccess={this.handleGoogleSuccess}
                      onError={() => toast.error("Login com Google falhou")}
                      useOneTap
                      theme="filled_blue"
                      width="100%"
                    />
                  </GoogleOAuthProvider>
                </Box>

                <Divider sx={{ my: 1 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ px: 1 }}>
                    OU CONTINUE COM EMAIL
                  </Typography>
                </Divider>
              </>
            )}

            <form onSubmit={this.handleSubmit}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  id="email"
                  label={loginType === "member" ? "E-mail de Membro" : "E-mail"}
                  variant="outlined"
                  type="email"
                  required
                  value={email}
                  onChange={this.handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  id="password"
                  label="Senha"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  required
                  value={password}
                  onChange={this.handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={this.handleTogglePassword} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Box sx={{ textAlign: "right" }}>
                  <Button
                    size="small"
                    component={Link}
                    to="/forgot-password"
                    startIcon={<KeyIcon sx={{ width: 14 }} />}
                    sx={{ textTransform: "none" }}
                  >
                    Esqueceu a palavra-passe?
                  </Button>
                </Box>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Turnstile
                    siteKey="0x4AAAAAADD5XelpNdivqvNc"
                    onSuccess={(token) => {
                      this.setState({ captchaToken: token });
                    }}
                  />
                </div>

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={this.state.captchaToken === ''}
                  size="large"
                  sx={{
                    borderRadius: 3,
                    py: 1.5,
                    fontWeight: "bold",
                    textTransform: "none",
                    boxShadow: "0 4px 14px 0 rgba(0,118,255,0.39)",
                  }}
                >
                  {loginType === "member" ? "Entrar como Membro" : "Entrar"}
                </Button>
              </Stack>
            </form>

            {loginType === "owner" && (
              <Box sx={{ mt: 2, textAlign: "center" }}>
                <Typography variant="body2" color="text.secondary">
                  Não tem uma conta?{" "}
                  <Button
                    component={Link}
                    to="/auth/register"
                    sx={{ textTransform: "none", fontWeight: "bold", p: 0, minWidth: "auto", ml: 0.5 }}
                  >
                    Criar conta
                  </Button>
                </Typography>
              </Box>
            )}
          </Paper>

          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Button
              component={Link}
              to="/"
              startIcon={<ArrowBack />}
              color="inherit"
              sx={{ textTransform: "none", opacity: 0.7 }}
            >
              Voltar para início
            </Button>
          </Box>
        </Container>
      </Box>
    );
  }
}

export default AuthLogin;